import { jsx as _jsx } from "react/jsx-runtime";
import { Image, Row, Column } from '@as/cotopaxi';
import { useAemConfig } from '@as-react/common-components';
import { ProductImageSizesPortraitEnum } from '@as-react/common-types';
import { Box } from '@yonderland/andes-react';
import { getImageSourceSetByProductCode } from '../../util/ImageUtil';
export const PromoBasketPopupPreview = ({ image, productCode }) => {
    const { productImageConfig } = useAemConfig();
    const imageUrl = getImageSourceSetByProductCode(productCode, image, productImageConfig)[ProductImageSizesPortraitEnum.basket];
    return (_jsx(Row, { clear: true, children: _jsx(Column, { gutter: false, grid: 0, mobile: 5, mobileLarge: 5, tabletSmall: 5, tablet: 12, desktop: 12, children: _jsx(Box, { paddingBlockEnd: "1", paddingInlineEnd: { md: '4' }, children: _jsx(Image, { src: imageUrl, alt: productCode, lazy: true }) }) }) }));
};
